import { Box, styled, Typography } from '@mui/material';

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
`;
export const SectionPermissions = styled(Box)`
  border: 1px solid #bdbdbd;
  border-radius: 4px;
`;
export const RowPermissions = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  gap: 88px;
  width: 100%;
  height: 60px;
  border: 1px solid #bdbdbd;
`;
export const TextName = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #616161;
`;
